export default __webpack_public_path__ + "static/media/Kannada_bm_2.eac4a4c9.mp3";